import React from "react";
import Header from "../../components/Header/Header";

function TypoGraphy() {
  return (
    <div className="container">
      <Header/>
      <h1> HomePage</h1>
      <h2> HomePage</h2>
      <h3> HomePage</h3>
      <h4> HomePage</h4>
      <h5> HomePage</h5>
      <h6> HomePage</h6>
      <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Illum rem cum laborum deserunt, delectus odit iure voluptate ex. Quaerat repellat consequatur placeat ex, eius nobis facere quod facilis at architecto.</p>
    </div>
  );
}

export default TypoGraphy;
